import type { StanTechniczny, StatusDokumentu, StatusStanu, TypDokumentu } from '../api/typy';

/** Etykiety statusów stanu — dokładnie te słowa, które były w arkuszu. */
export const STATUS_STANU: Record<StatusStanu, { etykieta: string; klasa: string; ton: 'ok' | 'uwaga' | 'blad' | 'neutralny' }> = {
  OK: { etykieta: 'OK', klasa: 'text-status-ok', ton: 'ok' },
  UZUPELNIJ: { etykieta: 'UZUPEŁNIJ', klasa: 'text-status-uzupelnij', ton: 'uwaga' },
  BRAK_STANU: { etykieta: 'BRAK STANU', klasa: 'text-status-brak', ton: 'blad' },
  POWYZEJ_MAX: { etykieta: 'POWYŻEJ MAX', klasa: 'text-status-nadmiar', ton: 'neutralny' },
};

export const TYP_DOKUMENTU: Record<TypDokumentu, { nazwa: string; opis: string; znak: '+' | '−' | '±' }> = {
  PZ: { nazwa: 'Przyjęcie', opis: 'Dostawa na stan magazynu', znak: '+' },
  WZ: { nazwa: 'Wydanie', opis: 'Wydanie na zajęcia albo inny cel', znak: '−' },
  ZW: { nazwa: 'Zwrot', opis: 'Rozliczenie zajęć', znak: '+' },
  KOR: { nazwa: 'Korekta', opis: 'Poprawa stanu wraz z uzasadnieniem', znak: '±' },
  MM: { nazwa: 'Przesunięcie', opis: 'Przeniesienie między lokalizacjami', znak: '±' },
  LIK: { nazwa: 'Likwidacja', opis: 'Zdjęcie ze stanu wraz z protokołem', znak: '−' },
};

export const STATUS_DOKUMENTU: Record<StatusDokumentu, { etykieta: string; ton: 'ok' | 'uwaga' | 'blad' | 'neutralny' }> = {
  SZKIC: { etykieta: 'szkic', ton: 'neutralny' },
  ZATWIERDZONY: { etykieta: 'zatwierdzony', ton: 'ok' },
  STORNOWANY: { etykieta: 'wystornowany', ton: 'blad' },
  ANULOWANY: { etykieta: 'anulowany', ton: 'neutralny' },
};

/** Które uprawnienie pozwala wystawić dany dokument. */
export const UPRAWNIENIE_DOKUMENTU: Record<TypDokumentu, string> = {
  PZ: 'ruch.przyjecie',
  WZ: 'ruch.wydanie',
  ZW: 'ruch.zwrot',
  KOR: 'ruch.korekta',
  MM: 'ruch.przesuniecie',
  LIK: 'ruch.likwidacja',
};

/** Stan techniczny egzemplarza sprzętu — etykieta i ton plakietki. */
export const STANY: Record<StanTechniczny, { etykieta: string; ton: 'ok' | 'uwaga' | 'blad' | 'neutralny' }> = {
  SPRAWNY: { etykieta: 'sprawny', ton: 'ok' },
  USZKODZONY: { etykieta: 'uszkodzony', ton: 'blad' },
  W_NAPRAWIE: { etykieta: 'w naprawie', ton: 'uwaga' },
  WYCOFANY: { etykieta: 'wycofany', ton: 'neutralny' },
  ZAGUBIONY: { etykieta: 'zagubiony', ton: 'blad' },
};
